<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title">Teams</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal text-white" @click="openCreateModal('createModal')">
          Add New Team
        </button>
      </div>
    </div>

    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger hover-white">
        <span class="material-symbols-outlined fs-6">undo</span> Reset
      </button>
    </div>

    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>

    <div class="card p-1 bg-white">
      <FormModal ref="createModal" title="Create New Team" id="create_team_form_modal">
        <CreateTeam ref="CreateTeamForm" @created="onCreated" @close="closeCreateModal('createModal')" />
      </FormModal>
      <FormModal ref="editTeamModal" title="Edit Team" id="edit_team_form_modal">
        <EditTeam v-if="selectedTeam" :external-id="selectedTeam.external_id" @updated="onTeamUpdated"
          @close="closeEditModal('editTeamModal')" />
      </FormModal>
      <LoadingBar v-if="loading" message="Loading Teams..." />

  <div v-else class="table-wrapper">
  <ListTable>

    <colgroup>
      <!-- <col style="width: 6%">   -->
      <col style="width: 32%">  <!-- Team -->
      <col style="width: 26%">  <!-- Members -->
      <col style="width: 18%">  <!-- Head -->
      <col style="width: 16%">  <!-- Description -->
      <col style="width: 8%">   <!-- Action -->
    </colgroup>

    <thead>
      <tr>
        <!-- <th>SR#</th> -->

        <th @click="sortBy('name')" class="sortable">
          Team <i :class="getSortIcon('name')"></i>
        </th>

        <th>Members</th>

        <th>Head</th>

        <th>Description</th>

        <th class="text-center">Action</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="team in teams" :key="team.external_id">

        <!-- SR# -->
        <!-- <td>
          
            {{ index + 1 }}
        </td> -->

        <!-- Team -->
        <td>
          <div class="mb-0" @click="viewDetails(team)" style="cursor: pointer;">

            {{ team.name }}</div>
          <div class="mt-0">
            <small class="text-muted">#{{ team.external_id }}</small>
          </div>
        </td>

        <!-- Members -->
        <td>
          <MembersDropdown
            :items="team.get_members"
            serial-key="external_id"
            label="Members"
            :name-keys="['first_name', 'last_name']"
            icon="users"
            row-icon="user"
          />
        </td>

        <!-- Head -->
        <td>
          {{ team.get_head?.first_name || '---' }}
          {{ team.get_head?.last_name || '' }}
        </td>

        <!-- Description -->
        <td>
          {{ $limit(team.description, 20, '...') }}
        </td>

        <!-- Action -->
        <td class="text-center">
          <TableActionDropdown>
            <li>
              <a class="dropdown-item" @click.prevent="viewDetails(team)">
                <i class="fa fa-eye text-info"></i>
                <span>Profile</span>
              </a>
            </li>

            <li>
              <a class="dropdown-item" @click.prevent="editTeam(team)">
                <i class="fa fa-pencil text-primary"></i>
                <span>Edit</span>
              </a>
            </li>

          
              <hr class="dropdown-divider" />
   

            <li>
              <a class="dropdown-item item-danger" @click.prevent="deleteTeam(team)">
                <i class="fa fa-trash"></i>
                <span>Delete</span>
              </a>
            </li>
          </TableActionDropdown>
        </td>

      </tr>

      <tr v-if="teams.length === 0">
        <td colspan="6" class="text-center py-4">
          No teams found
        </td>
      </tr>
    </tbody>

  </ListTable>
</div>

      <Pagination :pagination="pagination" @page-change="changePage" />
    </div>
  </div>
  <ConfirmDeleteModal
  v-model="showDeleteModal"
  title="Delete Team"
  :item-name="deletingTeam?.name"
  :loading="deleting"
  @confirm="confirmDelete"
/>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateTeam from '@/views/Team/CreateTeam.vue'
import ListTable from '@/components/utils/ListTable.vue'
import TableActionDropdown from '@/components/TableActionDropdown.vue'
import EditTeam from '@/views/Team/EditTeam.vue'
import MembersDropdown from '@/components/AttributesDropdown.vue'
import ConfirmDeleteModal from '@/components/utils/ConfirmDeleteModal.vue'
export default {
  name: 'TeamList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateTeam,
    ListTable,
    TableActionDropdown,
    EditTeam,
    MembersDropdown,
      ConfirmDeleteModal
  },
  data() {
    return {
      teams: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      filteredData: [],
      currentFilters: {},
      sortColumn: 'name',
      sortOrder: 'asc',
      filterManager: null,
      dropdownUsers: [], 
        showDeleteModal: false,
      deletingTeam:    null,
      deleting:        false,
    }
  },
  computed: {
    sortedData() {
      let result = [...this.filteredData];
      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];
          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';
          if (this.sortColumn === 'id') {
            valA = parseInt(String(valA).replace('#', '')) || 0;
            valB = parseInt(String(valB).replace('#', '')) || 0;
          }
          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();
          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }
      return result;
    },
  },
  async mounted() {
    await this.getUsers() // Load users first
    this.fetchList()
    this.$nextTick(() => {
      setTimeout(() => {
        this.initFilters();
      }, 100);
    });
  },
  methods: {
    openCreateModal(ref) {
      this.$refs[ref].showModal()
    },
    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },
    async onCreated() {
      this.pagination.current_page = 1
      await this.fetchList()
    },

    // Get users for dropdown
    async getUsers() {
      const result = await form_api_submit({
        url: 'user/dropdown',
        method: 'GET',
        show_success_toast: false,
        show_error_toast: true,
      })

      if (result.success && result.data) {
        this.dropdownUsers = (result.data || []).map(user => ({
          value: user.external_id || user.id,
          label: `${user.first_name} ${user.last_name}`
        }))
      } else {
        this.dropdownUsers = []
      }
    },

    async fetchList() {
      this.loading = true

      const result = await form_api_submit({
        url: 'team/list',
        method: 'GET',
        data: {
          page: this.pagination.current_page,
          name: this.currentFilters?.name || '',
          user: this.currentFilters?.user || '', // Send user filter
        },
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        this.teams = result.data.list
        this.filteredData = result.data.list
        this.pagination = result.data.pagination
      }

      this.loading = false
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      this.fetchList()
    },

    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      // Prepare user options for dropdown
      const userOptions = this.dropdownUsers.map(u => ({
        value: u.value,
        label: u.label || 'Unnamed'
      }))

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "name",
            label: "Team Name",
            type: "input",
            placeholder: "Filter by Team Name"
          },
          {
            key: "user",
            label: "User",
            type: "checkbox",
            options: userOptions
          }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      this.currentFilters = { ...activeFilters };
      this.pagination.current_page = 1;
      this.fetchList();
    },

    resetPagination() {
      this.pagination.current_page = 1;
      this.fetchList();
    },

    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.currentFilters = {};
      this.sortColumn = 'name';
      this.sortOrder = 'asc';
      this.pagination.current_page = 1;
      this.fetchList();
    },

    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
      this.resetPagination();
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },
    editTeam(team) {
      this.selectedTeam = team
      this.$refs.editTeamModal.showModal()
    },
    closeEditModal(ref) {
      if (this.$refs[ref]) {
        this.$refs[ref].closeModal()
      }
    },
    async onTeamUpdated() {
      this.pagination.current_page = 1
      await this.fetchList()
    },
    viewDetails(team) {
      this.$router.push({ name: 'TeamProfile', params: { external_id: team.external_id } })
    },
      deleteTeam(team) {
      this.deletingTeam= team
      this.showDeleteModal = true
    },

    async confirmDelete() {
      this.deleting = true
      try {
        const result = await form_api_submit({
          url: `team/delete/${this.deletingTeam.external_id}`,
          method: 'POST',
          show_success_toast: true,
          show_error_toast: true,
        })
        if (result.success) {
          this.showDeleteModal = false
          this.deletingTeam= null
          this.fetchList()
        }
      } finally {
        this.deleting = false
      }
    },
  }
}
</script>

<style scoped>
.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}
</style>